import { render, staticRenderFns } from "./BookPc.vue?vue&type=template&id=0c6cc69a&scoped=true&"
import script from "./BookPc.vue?vue&type=script&lang=js&"
export * from "./BookPc.vue?vue&type=script&lang=js&"
import style0 from "./BookPc.vue?vue&type=style&index=0&id=0c6cc69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6cc69a",
  null
  
)

export default component.exports